import ExpanderPanel from '@rio-cloud/rio-uikit/ExpanderPanel';
import type { Account, ManEulaStatus } from '../../../../services/schemas/accountsBackendCodec';
import { FormattedDateTime } from '../../../common/FormattedDateTime';
import { AccountLifeCycleInformationUpdate } from '../dialogs/AccountLifeCycleInformationUpdate';
import { toFormAccount } from '../formAccount';
import { ModifiedAccountData } from './ModifiedAccountData';
import { lockingOptions } from './formOptions';

interface AccountDetailProps {
    account: Account;
    eulaStatus: ManEulaStatus | undefined;
    minAccountAcr: string | undefined;
}

export const AccountDetails = (props: AccountDetailProps) => {
    const { account, eulaStatus, minAccountAcr } = props;

    const mapLockedBecauseIdToLabel = (id: string) => {
        return lockingOptions.find(option => id === option.id)?.label;
    };

    const acrValue = (acr: string) => {
        switch (acr) {
            case 'urn:rio:loa:1':
                return 'None (urn:rio:loa:1)';
            case 'urn:rio:loa:2':
                return 'OTP (urn:rio:loa:2)';
            default:
                return acr;
        }
    };

    return (
        <div className='width-100pct'>
            <ModifiedAccountData formAccount={toFormAccount(account)} eulaStatus={eulaStatus} />
            {minAccountAcr && (
                <ExpanderPanel
                    open={false}
                    title={
                        <table className='table table-condensed'>
                            <thead>
                                <tr className={'text-color-dark bg-lightest'}>
                                    <td colSpan={2} style={{ paddingLeft: '12px' }}>
                                        Security
                                    </td>
                                </tr>
                            </thead>
                        </table>
                    }
                    headerClassName='padding-0 position-relative text-color-dark bg-lightest'
                    titleClassName='width-100pct margin-0 overflow-hidden'
                    bodyClassName='padding-0'
                    iconClassName='margin-right-5'
                    className='overflow-hidden rounded-none'
                >
                    <table className='table table-condensed table-layout-fixed'>
                        <tbody>
                            <tr>
                                <td style={{ paddingLeft: '12px' }}>Enforced MFA</td>
                                <td>{acrValue(minAccountAcr)}</td>
                            </tr>
                        </tbody>
                    </table>
                </ExpanderPanel>
            )}
            <ExpanderPanel
                open={false}
                title={
                    <table className='table table-condensed'>
                        <thead>
                            <tr className={'text-color-dark bg-lightest'}>
                                <td colSpan={2} style={{ paddingLeft: '12px' }}>
                                    Locking info
                                </td>
                            </tr>
                        </thead>
                    </table>
                }
                headerClassName='padding-0 position-relative text-color-dark bg-lightest'
                titleClassName='width-100pct margin-0 overflow-hidden'
                bodyClassName='padding-0'
                iconClassName='margin-right-5'
                className='overflow-hidden rounded-none'
            >
                {account.lifeCycleStateInformation ? (
                    <>
                        <table className='table table-condensed'>
                            <tbody>
                                <tr>
                                    <td style={{ paddingLeft: '12px' }}>Locked Because</td>
                                    <td style={{ paddingLeft: '12px' }}>
                                        {mapLockedBecauseIdToLabel(account.lifeCycleStateInformation.lockedBecause)}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ paddingLeft: '12px' }}>Locked At</td>
                                    <td style={{ paddingLeft: '12px' }}>
                                        {account.lifeCycleStateInformation?.lockedAt ? (
                                            <FormattedDateTime value={account.lifeCycleStateInformation.lockedAt} />
                                        ) : (
                                            <span className={'text-light'}>
                                                <i>unknown</i>
                                            </span>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ paddingLeft: '12px' }}>Locked Notes</td>
                                    <td style={{ paddingLeft: '12px', paddingRight: '12px' }}>
                                        <textarea
                                            value={account.lifeCycleStateInformation?.lockedNotes}
                                            rows={account.lifeCycleStateInformation?.lockedNotes ? 5 : 3}
                                            disabled={true}
                                            style={{ width: '350px', resize: 'vertical' }}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className={'pull-right margin-right-20'}>
                            <AccountLifeCycleInformationUpdate account={account} />
                        </div>
                    </>
                ) : (
                    <table className='table table-condensed'>
                        <tbody>
                            <tr>
                                <td style={{ paddingLeft: '12px' }}>No lifecycle state info available</td>
                            </tr>
                        </tbody>
                    </table>
                )}
            </ExpanderPanel>
        </div>
    );
};
